import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import DcDcConverterSizingCalculator from '../components/tools/DcDcConverterSizingCalculator';

const DcDcConverterSizingCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="dcdc-converter-sizing-calculator-page">
      <PageHero
        eyebrow="Power Electronics"
        title="DC-DC Converter Sizing Tool"
        description="From a vehicle electrical load list and source voltage behavior to a defensible minimum converter spec, with every margin, derating factor, and assumption traceable and editable."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="dcdc-converter-sizing-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <DcDcConverterSizingCalculator />
          <ToolGuideCta guidePath="/tools/dcdc-converter-sizing-calculator/guide" toolName="DC-DC Converter Sizing Tool" />
        </div>
      </section>
    </div>
  );
};

export default DcDcConverterSizingCalculatorPage;
